var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUnlockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.684 11.81a1.055 1.055 0 0 0-.767-.31H8.61V7.958c0-.782.282-1.45.846-2.003a2.812 2.812 0 0 1 2.043-.83 2.81 2.81 0 0 1 2.043.83c.564.553.846 1.221.846 2.003 0 .192.071.358.214.498.143.14.313.21.508.21h.723c.195 0 .364-.07.507-.21a.675.675 0 0 0 .215-.498c0-1.365-.495-2.532-1.484-3.503C14.082 3.485 12.892 3 11.5 3s-2.582.485-3.572 1.455c-.989.97-1.484 2.138-1.484 3.503V11.5h-.36c-.301 0-.557.103-.768.31-.21.206-.316.457-.316.752v6.376c0 .295.105.546.316.752.21.207.466.31.767.31h10.834c.3 0 .557-.103.767-.31.21-.206.316-.457.316-.753v-6.375c0-.295-.105-.545-.316-.752z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlockWhite);
export default __webpack_public_path__ + "static/media/ic_unlock_white.685fd3dc8623acc97ded5aac66cd711b.svg";
export { ForwardRef as ReactComponent };